import { Component, Input } from '@angular/core';
import { BaseControl } from '../base-control';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

export enum MultiTextArrayType {
  STRING,
  ARRAY
}

@Component({
  selector: 'multi-text-input',
  templateUrl: './multi-text-input-control.component.html',
  styleUrls: ['./multi-text-input-control.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: MultiTextInputControlComponent,
    multi: true
  }]
})
export class MultiTextInputControlComponent extends BaseControl {
  @Input() public label: string = '';
  @Input() public icon: string = '';
  @Input() public maxInputs: number = 3;
  @Input() public arrayType: MultiTextArrayType = MultiTextArrayType.STRING;
  @Input() public type: string = 'text';
  
  newItem: string = '';
  items: string[];

  constructor() {
    super();

    this.items = [];
  }

  onWriteValue(value) {
    if (this.arrayType == MultiTextArrayType.STRING) {
      if (value != null && value.length > 0) {
        let data = value as string;
        this.items = data.split(',');
      }
    }
    else {
      let data = value as Array<string>;
      this.items = data.concat([]);
    }
  }

  addItem() {
    this.items.push(this.newItem);
    this.newItem = '';
    this.updateItems();
  }

  removeItem(index: number) {
    this.items.splice(index, 1);
    this.updateItems();
  }

  updateItems() {
    if (this.arrayType == MultiTextArrayType.STRING) {
      this.value = this.items.join(',');
    }
    else {
      this.value = this.items.concat([]);
    }

    this.updateValue();
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

}
